import { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { ESTILO_BOTON_LISTAR_NUEVO, ESTILO_BOTON_MODAL_ACEPTAR } from "../../../utils/const/estilos-const";
import ModalConfirmar from "../../../components/modal-confirmar";
import "../../../style/style-cargando.css";
import cargandoCard from "../../../components/cargando-card";
import sinAccesoCard from "../../../components/sin-acceso-card";
// import { Settings } from "feather-icons-react/build/IconComponents";
import { deshabilitarProducto, habilitarProducto, obtenerListaProducto } from "../../../api/api-producto";
import { sharedMensajeConfirmacion, sharedNextPage, sharedApiErrorMessage } from "../../../utils/shared-functions";
import { SELECT_HABILITADO_DESHABILITADO } from "../../../utils/const/const-select-habilitado-deshabilitado";
import Select from "react-select";
// import ArrowBack from "../../../components/arrow-back";
import { useTranslation } from "react-i18next";
import { useProcessing, useToast } from "../../../utils/context/ui-feedback-context";
import GridComponent from "../../../components/grid";
import { STRING_TIPO_DE_IMAGEN } from "../../../utils/const/string-const";

// let $ = window.$;
// let DevExpress = window.DevExpress;
// console.log("DevExpress");
// console.log(DevExpress);
// if (DevExpress?.ui?.themes) {
// console.log("DevExpress.ui está disponible");
//   DevExpress.ui.themes.current("light.compact");
// } else {
// console.warn("DevExpress.ui no está disponible");
// }

export default function ListarProductoPage
  () {
  const { t } = useTranslation();

  const history = useHistory();
  const [cargandoPage, setCargandoPage] = useState(true);

  const [modalConfirmarDeshabilitarVisible, setModalConfirmarDeshabilitarVisible] = useState(false);
  const [modalConfirmarHabilitarVisible, setModalConfirmarHabilitarVisible] = useState(false);
  const [elementoSelected, setElementoSelected] = useState(null);
  // const [permisos, setPermisos] = useState(null);
  const [tieneAccesoAlModulo, setTieneAccesoAlModulo] = useState(true);
  const [habilitadoSelected, setHabilitadoSelected] = useState(null);

  const [rowsData, setRowsData] = useState([]);

  // Toast only (success / error messages)
  const { showToast } = useToast();
  // Processing overlay only (loading while API runs)
  const { showProcessing, hideProcessing } = useProcessing();




  const headers = [
    { key: "acciones", title: "ACCIONES" },
    { key: "id", title: "ID", visible: false, },
    { key: "codigo", title: t('column_codigo'), visible: true, filter: true, editLabel: false, },
    { key: "nombre", title: t('column_nombre'), visible: true, filter: true, editLabel: false, },
    { key: "descripcion", title: t('column_descripcion'), visible: true, filter: true, editLabel: false, },
    { key: "nota", title: t('column_nota'), visible: true, filter: true, editLabel: false, },
    { key: "habilitado", title: t('column_estado'), visible: false, filter: true, editLabel: false, },
    { key: "habilitadoLabel", title: t('column_estado'), visible: true, filter: true, editLabel: false, },
    { key: "fechaProceso", title: t('column_fecha_proceso'), visible: true, filter: true, editLabel: false, },
  ];

  useEffect(() => {
    iniciar();
  }, []);

  const iniciar = async () => {
    try {
      let objEnviar = {};
      objEnviar.habilitado = habilitadoSelected !== null ? habilitadoSelected.value : null;
      /*let obj = {};
      obj.idMenuPrimerNivel = INT_ID_MODULO_CHECKLIST;
      obj.idMenuSegundoNivel = INT_ID_SEGUNDO_NIVEL_ADMINISTRACION_CHECKLIST;
      obj.idMenuTercerNivel = INT_ID_TERCER_NIVEL_CHECKLIST_OPCIONES_RESPUESTA;
      let obtenerPermisos = await obtenerPermisosPorNivelUsuarioWeb(obj);
      let permiso = obtenerPermisos[0];
      setPermisos(permiso);
      */

      const responseListaProducto = await obtenerListaProducto(objEnviar, false, t);
      // console.log('responseListaProducto');
      // console.log(responseListaProducto);
      if (responseListaProducto.error === false) {
        // setRowsData(responseListaProducto.data);
        agregarAccionesALista(responseListaProducto.data, null);
      }
      if (responseListaProducto.error === true) {
        showToast(
          sharedApiErrorMessage(responseListaProducto.message, t("alert_process_failed")),
          "error",
          3000
        );
      }
    } catch (err) {
      console.log('iniciar err');
      console.log(err);
    } finally {
      setCargandoPage(false);
    }

  };

  const agregarAccionesALista = (lista, permiso) => {
    try {
      // console.log('agregarAccionesALista');
      // console.log(lista);
      if (lista.length === 0) {
        setRowsData(lista);
      }
      if (lista.length > 0) {
        const objModificar = {
          label: t('btn_modificar'),
          color: "green",
          onClick: (param) => modificarElementoSelected(param),
        };
        const objDeshabilitar = {
          label: t('btn_deshabilitar'),
          color: "red",
          onClick: (param) => deshabilitarElementoSelected(param),
        };
        const objHabilitar = {
          label: t('btn_habilitar'),
          color: "green",
          onClick: (param) => habilitarElementoSelected(param),
        };
        for (let i = 0; i < lista.length; i++) {
          const elemento = lista[i];
          let acciones = [];
          acciones.push(objModificar);
          if (elemento.habilitado === 1) {
            acciones.push(objDeshabilitar);
          }
          if (elemento.habilitado === 0) {
            acciones.push(objHabilitar);
          }
          lista[i].acciones = acciones;
        }
        setRowsData(lista);
      }
    } catch (err) {
      console.log('agregarAccionesALista err');
      console.log(err);
    }
  }

  const modificarElementoSelected = (data) => {
    try {
      console.log("modificarElementoSelected");
      console.log(data);
      if (data.acciones !== undefined) {
        delete data.acciones;
      }
      let obj = {};
      obj.titulo = t("label_modificar_producto");
      obj.params = data;
      // console.log('obj');
      // console.log(obj);
      sharedNextPage("producto", obj, history);
    } catch (err) {
      console.log("modificarElementoSelected err");
      console.log(err);
    }
  };

  const deshabilitarElementoSelected = async (data) => {
    try {
      // console.log("deshabilitarElementoSelected");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarDeshabilitarVisible(true);
    } catch (err) {
      console.log("deshabilitarElementoSelected err");
      console.log(err);
    }
  };

  const habilitarElementoSelected = async (data) => {
    try {
      // console.log("habilitarElementoSelected");
      // console.log(data);
      setElementoSelected(data);
      setModalConfirmarHabilitarVisible(true);
    } catch (err) {
      console.log("habilitarElementoSelected err");
      console.log(err);
    }
  };

  const handleNuevoClick = () => {
    let obj = {};
    obj.titulo = t("label_crear_producto");
    obj.params = {
      id: 0,
      idCategoriaProducto: "",
      slug: "",
      codigo: "",
      nombre: "",
      descripcion: "",
      precioOriginal: "",
      porcentajeDescuento: 0,
      precio: "",
      idMoneda: "",
      tipoImagenPrincipal: STRING_TIPO_DE_IMAGEN.image,
      imagenPrincipal: "",
      tipoImagenes: STRING_TIPO_DE_IMAGEN.image,
      imagenes: [],
      rating: "",
      cantidadDisponiblePublico: 0,
      cantidadDisponiblePrivado: 0,
      idBadge: "",
      publico: 1,
      habilitado: 1,
    };
    sharedNextPage("producto", obj, history);
  };

  const reset = async () => {
    setCargandoPage(true);
    iniciar();
  };

  const handleConfirmModalDeshabilitar = async () => {
    setModalConfirmarDeshabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    showProcessing();
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await deshabilitarProducto(objEnviar);
      hideProcessing();
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_deshabilito_correctamente"));
        reset();
      }
      if (response.error === true) {
        showToast(sharedApiErrorMessage(response.message, t("alert_process_failed")), "error", 3000);
      }
    }
  };

  const handleConfirmHabilitarModal = async () => {
    setModalConfirmarHabilitarVisible(false);
    if (elementoSelected == null) {
      return;
    }
    let objEnviar = {};
    objEnviar.id = elementoSelected.id;
    if (elementoSelected.id !== 0) {
      // console.log('crear correo');
      const response = await habilitarProducto(objEnviar);
      // console.log('creado');
      // console.log(creado);
      if (response.error === false) {
        showToast(t("alert_se_habilito_correctamente"), "success", 3000);
        reset();
      }
      if (response.error === true) {
        showToast(sharedApiErrorMessage(response.message, t("alert_process_failed")), "error", 3000);
      }
    }
  };

  const render = () => {
    try {
      // console.log('listar correo render');
      if (cargandoPage === true) {
        return cargandoCard();
      }
      if (tieneAccesoAlModulo === false) {
        return sinAccesoCard();
      }
      return (
        <div className="max-w-7xl mx-auto px-4 lg:px-6">
          <div className="flex items-center justify-between py-4">
            <div>
              <div className="flex items-center gap-2">
                {/* <ArrowBack onClick={handleAtrasClick} /> */}
                <h2 className="text-xl font-bold text-gray-900">{t("label_gestionar_producto")}</h2>
              </div>
              <p className="text-sm text-gray-500">{t("label_administra_la_lista_de_productos")}</p>
            </div>
            <div className="flex items-center gap-2">
              <button
                type="button"
                className={ESTILO_BOTON_LISTAR_NUEVO}
                onClick={() => {
                  handleNuevoClick();
                }}
              >
                {t("label_nuevo")}
              </button>
            </div>
          </div>
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                {t("label_estado")}
              </label>
              <Select options={SELECT_HABILITADO_DESHABILITADO}
                isSearchable={true}
                isClearable={true}
                value={habilitadoSelected}
                onChange={(event) => setHabilitadoSelected(event)}
                placeholder={t("placeholder_seleccione_estado")}
              />
            </div>
            <div className="col-span-12 md:col-span-6 lg:col-span-3 xl:col-span-3">
              <label className="block text-[#0F3457] font-semibold mb-2" htmlFor="habilitado">
                &nbsp;
              </label>
              <button
                type="button"
                className={ESTILO_BOTON_MODAL_ACEPTAR}
                onClick={() => { reset(); }}
              >
                {t("label_buscar")}
              </button>
            </div>
          </div>
          <br />
          {/* Grid Card */}
          <GridComponent rows={rowsData} headers={headers} />
          <ModalConfirmar
            isOpen={modalConfirmarDeshabilitarVisible}
            onCancel={() => { setModalConfirmarDeshabilitarVisible(false); }}
            onConfirm={handleConfirmModalDeshabilitar}
            message={sharedMensajeConfirmacion(t("alert_esta_seguro_de_deshabilitar"), elementoSelected?.descripcion)}
          />
          <ModalConfirmar
            isOpen={modalConfirmarHabilitarVisible}
            onCancel={() => { setModalConfirmarHabilitarVisible(false); }}
            onConfirm={handleConfirmHabilitarModal}
            message={sharedMensajeConfirmacion(t("alert_esta_seguro_de_habilitar"), elementoSelected?.descripcion)}
          />
        </div>
      );
    } catch (err) {
      console.log('ListarArea render err');
      console.log(err);
      return (
        <div><label>{JSON.stringify(err)}</label></div>
      );
    }
  }

  return render();
}
